// Generated code for Big.Entities.BetalingsType.
// Edit _Enum.tst to change the generated output.

export enum BetalingsType {
    onbekend = 0,
    automatischInterpay = 1,
    handmatig = 2,
    internetkassa = 3,
    overig = 4,
    ideal = 5,
    creditCard = 6,
    zelfOvermaken = 7,
    gbm = 8
}
(BetalingsType as any).name = 'BetalingsType';
